import React from "react";

const HakkimizContent = () => {
  return (
    <div>
      <div className="py-12 bg-white ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:text-center">
            <h2 className="font-heading mb-4 bg-orange-100 px-4 py-2 rounded-lg md:w-64 md:mx-auto text-xs font-semibold tracking-widest text-black uppercase title-font">
              Neden Bizi Seçmelisiniz?
            </h2>
            <p className="font-heading mt-2 text-3xl leading-8 font-bold tracking-tight text-gray-900 sm:text-4xl">
              Hakkımızda
            </p>
            <p className="mt-4 max-w-2xl text-lg text-gray-950 lg:mx-auto">
              Jojo Turizm Türkiye’nin önde gelen Kurumsal Seyahat Yönetimi
              şirketidir. 2017 yılında kurulan şirket yaklaşık 7 yıllık kurumsal
              seyahat deneyimine sahiptir. Jojo, aşırı talepçi ve zorlu iş
              dünyasında, daima yenilikçi tutumu ile müşterilerinin tüm
              ihtiyaçlarına cevap verebilen geniş kapsamlı bir hizmet yelpazesi
              sunmakla gurur duymaktadır. <br />
              <br /> IATA havayollarının iç ve dış hat uçak biletlerini,
              Biletbank rezervasyon sistemi ile online olarak, en son koltuk
              bazında yer ayırıp taleplerinizi anında karşılamaktayız. Dünya
              çapında 150,000’i aşkın otele ve belli başlı araba kiralama
              şirketlerine anında rezervasyon hizmeti sunmaktayız. <br />
              <br /> Müşterilerine değer yaratma esası üzerine kurulu
              anlayışıyla, Kurumsal Seyahat Yönetimi, Danışmanlık, Toplantı ve
              Organizasyon Yönetimi, Spor Turizmi ve Bütçe Yönetimi konularda
              kişiye özel hizmetler üretmekteyiz.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HakkimizContent;
